webpackJsonp([169315112914517],{

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCycle = function ImageCycle(props) {
		return _react2.default.createElement('div', {
			className: 'image-cycle',
			style: {
				background: 'url(' + props.image.file.url + ') top center no-repeat',
				backgroundSize: 'cover'
			}
		});
	};
	
	exports.default = ImageCycle;
	module.exports = exports['default'];

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _gsap = __webpack_require__(29);
	
	var _gsap2 = _interopRequireDefault(_gsap);
	
	var _reactTransitionGroup = __webpack_require__(112);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _BannerImage = __webpack_require__(63);
	
	var _BannerImage2 = _interopRequireDefault(_BannerImage);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _scroller = __webpack_require__(71);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _ImageCycle = __webpack_require__(339);
	
	var _ImageCycle2 = _interopRequireDefault(_ImageCycle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var careers = function (_React$Component) {
		_inherits(careers, _React$Component);
	
		function careers(props) {
			_classCallCheck(this, careers);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.state = {
				sliderActive: 0
			};
	
			return _this;
		}
	
		careers.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			var _props$data = this.props.data,
			    page = _props$data.page,
			    posts = _props$data.posts;
			// const { sliderActive } = this.state
	
			this.sliderInterval = setInterval(function () {
				var sliderActive = _this2.state.sliderActive;
	
				var newActiveIndex = sliderActive >= page.slider.length - 1 ? 0 : sliderActive + 1;
				_this2.setState({ sliderActive: newActiveIndex });
			}, 4500);
		};
	
		careers.prototype.enterSliderImage = function enterSliderImage(node) {};
	
		careers.prototype.exitSliderImage = function exitSliderImage(node) {
			TweenMax.set(node, {
				css: { position: 'absolute', zIndex: 10, top: 0, left: 0 }
			});
			TweenMax.to(node, 1.4, { autoAlpha: 0 });
		};
	
		careers.prototype.componentWillUnmount = function componentWillUnmount() {
			clearInterval(this.sliderInterval);
		};
	
		careers.prototype.getJobCategories = function getJobCategories() {
			var posts = this.props.data.posts;
	
	
			var jobCategories = [];
	
			posts.edges.forEach(function (job) {
				if (job.node.jobCategory != null && jobCategories.indexOf(job.node.jobCategory) === -1) {
					jobCategories.push(job.node.jobCategory);
				}
			});
			return jobCategories;
		};
	
		careers.prototype.render = function render() {
			var _this3 = this;
	
			var _props$data2 = this.props.data,
			    page = _props$data2.page,
			    posts = _props$data2.posts;
	
			console.log('PAGE INFO ==> ', posts);
	
			var jobCategories = this.getJobCategories();
			return _react2.default.createElement(
				'div',
				{ className: 'careers page-redesign' },
				_react2.default.createElement(_CustomHelmet2.default, { data: page.seoData, fallBack: page }),
				_react2.default.createElement(_Hero2.default, { title: page.title }),
				_react2.default.createElement(
					_Row2.default,
					{ className: 'contentWrapper capper' },
					_react2.default.createElement(
						_Column2.default,
						{ width: '12' },
						_react2.default.createElement(
							'h2',
							{ className: 'h2 intro' },
							page.secondaryHeadline
						),
						page.introText && _react2.default.createElement('div', {
							className: 'expanded',
							dangerouslySetInnerHTML: {
								__html: (0, _marked2.default)(page.introText.introText)
							}
						})
					)
				),
				_react2.default.createElement(
					_Row2.default,
					{ className: 'contentWrapper capper no-top-padding' },
					_react2.default.createElement(
						_Column2.default,
						{ width: '6', offsetL: '3', tablet: '12', mobile: '12' },
						posts.edges && _react2.default.createElement(
							'div',
							{ className: 'job-openings' },
							_react2.default.createElement(
								'h2',
								{ className: 'h2 intro' },
								'Central Office'
							),
							jobCategories.indexOf('Central Office') !== -1 && _react2.default.createElement(
								'span',
								null,
								posts.edges.map(function (post) {
									if (post.node.jobCategory === 'Central Office' && post.node.showOnCareersPage) {
										var _React$createElement;
	
										return _react2.default.createElement(
											'div',
											(_React$createElement = {
												key: post.node.id,
												className: 'job'
											}, _React$createElement['key'] = post.node.id, _React$createElement),
											_react2.default.createElement(
												'h4',
												null,
												post.node.jobTitle
											),
											_react2.default.createElement(
												'p',
												null,
												post.node.excerpt
											),
											_react2.default.createElement(
												'a',
												{ href: post.node.slug, className: 'hoverlink', taget: '_blank' },
												'See the position'
											)
										);
									}
								})
							),
							jobCategories.indexOf('Oakland') === -1 && _react2.default.createElement(
								'p',
								null,
								'There are currently no job opportunities posted for this team. Please check back soon!'
							)
						)
					),
					_react2.default.createElement(
						_Column2.default,
						{ width: '6', offsetL: '3', tablet: '12', mobile: '12' },
						posts.edges && _react2.default.createElement(
							'div',
							{ className: 'job-openings' },
							_react2.default.createElement(
								'h2',
								{ className: 'h2 intro' },
								'Alumni Opportunities'
							),
							jobCategories.indexOf('Alumni Opportunities') !== -1 && _react2.default.createElement(
								'span',
								null,
								posts.edges.map(function (post) {
									if (post.node.jobCategory === 'Alumni Opportunities' && post.node.showOnCareersPage) {
										var _React$createElement2;
	
										return _react2.default.createElement(
											'div',
											(_React$createElement2 = {
												key: post.node.id,
												className: 'job'
											}, _React$createElement2['key'] = post.node.id, _React$createElement2),
											_react2.default.createElement(
												'h4',
												null,
												post.node.jobTitle
											),
											_react2.default.createElement(
												'p',
												null,
												post.node.excerpt
											),
											_react2.default.createElement(
												'a',
												{ href: post.node.slug, className: 'hoverlink', target: '_blank' },
												'See the position'
											)
										);
									}
								})
							),
							jobCategories.indexOf('Alumni Opportunities') === -1 && _react2.default.createElement(
								'p',
								null,
								'There are currently no job opportunities posted for this team. Please check back soon!'
							)
						)
					)
				),
				_react2.default.createElement(
					_Row2.default,
					{ className: 'contentWrapper capper no-top-padding' },
					_react2.default.createElement(
						_Column2.default,
						{ width: '12' },
						page.sliderSectionTitle && _react2.default.createElement(
							'h2',
							{ className: 'h2' },
							page.sliderSectionTitle
						)
					),
					_react2.default.createElement(
						_Column2.default,
						{ width: '6', tablet: '12', className: 'career-slide' },
						_react2.default.createElement(
							_reactTransitionGroup.TransitionGroup,
							null,
							_react2.default.createElement(
								_reactTransitionGroup.Transition,
								{
									key: this.state.sliderActive,
									timeout: 1500,
									onEnter: function onEnter(node) {
										return _this3.enterSliderImage(node);
									},
									onExit: function onExit(node) {
										return _this3.exitSliderImage(node);
									}
								},
								_react2.default.createElement(_ImageCycle2.default, { image: page.slider[this.state.sliderActive] })
							)
						)
					),
					_react2.default.createElement(
						_Column2.default,
						{ width: '6', tablet: '12' },
						page.sliderIntro && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('span', {
								dangerouslySetInnerHTML: {
									__html: (0, _marked2.default)(page.sliderIntro.sliderIntro)
								}
							}),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'a',
								{ href: page.link.link, className: 'hoverlink' },
								page.link.text
							)
						)
					)
				),
				_react2.default.createElement(
					_Row2.default,
					{ className: 'contentWrapper bg-grey' },
					_react2.default.createElement(
						_Row2.default,
						{ className: 'no-padding contentWrapper capper' },
						_react2.default.createElement(
							_Column2.default,
							{ width: '12' },
							_react2.default.createElement(
								'h2',
								{ className: 'h2' },
								page.perksTitle
							),
							_react2.default.createElement('p', {
								className: 'expanded',
								dangerouslySetInnerHTML: { __html: page.perksIntro.perksIntro }
							}),
							_react2.default.createElement(
								_Row2.default,
								{ className: 'no-side-padding no-bottom-padding' },
								page.icons.map(function (icon, index) {
									return _react2.default.createElement(
										_Column2.default,
										{
											key: index,
											width: '4',
											tablet: '6',
											mobile: '12',
											className: 'icon-wrapper'
										},
										_react2.default.createElement('div', {
											className: 'icon',
											style: {
												background: 'url(' + icon.icon.file.url + ') left center no-repeat',
												backgroundSize: 'contain'
											}
										}),
										_react2.default.createElement(
											'h3',
											{ className: 'title' },
											icon.title
										),
										_react2.default.createElement(
											'p',
											{ className: 'details' },
											icon.excerpt.excerpt
										)
									);
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: 'bg-dark-grey' },
					_react2.default.createElement(
						'div',
						{ className: 'block standard-spacing block-download' },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/fMmwEP0R4EYEBDAPYbGPb/8bc162a09d5fe53bfb47807a516bdbcf/DEIA_Report_preview.png', alt: 'booklet mockup' })
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'h3',
								{ className: 'boldItal color-white' },
								'DOWNLOAD OUR DEIA PROGRESS REPORT'
							),
							_react2.default.createElement(
								'p',
								{ className: 'color-white' },
								'We are continuously striving to deepen our commitment to diversity, equity, inclusion, and anti-racism. We\u2019re sharing this report openly in an effort to lead out loud and be transparent about what we\u2019re learning, what we\u2019re doing well, and what we can improve.'
							),
							_react2.default.createElement(
								'a',
								{ href: 'https://downloads.ctfassets.net/j91b9gwu8s3q/3TFzDCU13hSUYmbn02RG36/459fcd6aa98e94b3a5dc2a6bdc5e7c33/Global_Citizen_Year_-_DEIA_Progress_Report.pdf', target: '_blank', className: 'hoverlink white' },
								'Download Now'
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'section' },
					_react2.default.createElement(
						'div',
						{ className: 'banner-wrap' },
						_react2.default.createElement(_BannerImage2.default, { image: page.bannerImage })
					)
				)
			);
		};
	
		return careers;
	}(_react2.default.Component);
	
	exports.default = careers;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-careers-js-9dc6f97edfcc0bcf7457.js